import React from 'react';
import Navigation from './components/Navigation';
import Home from './components/Home';
import About from './components/About';
import Work from './components/Work';
import BlogGallery from './components/BlogGallery';
import Services from './components/Services';
import ProjectRegistration from './components/ProjectRegistration';
import ImageSection from './components/ImageSection';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Home />
      <About />
      <Work />
      <BlogGallery />
      <Services />
      <ProjectRegistration />
      <ImageSection />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
